var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.194 11.226v1.548c0 .32-.262.58-.581.58h-4.258v4.259c0 .32-.261.58-.58.58h-1.55a.58.58 0 0 1-.58-.58v-4.258H6.387a.58.58 0 0 1-.58-.58v-1.55c0-.319.26-.58.58-.58h4.258V6.387c0-.32.261-.58.58-.58h1.55c.319 0 .58.26.58.58v4.258h4.258c.32 0 .58.261.58.58M24 12c0 6.629-5.371 12-12 12S0 18.629 0 12 5.371 0 12 0s12 5.371 12 12m-2.323 0A9.675 9.675 0 0 0 12 2.323 9.675 9.675 0 0 0 2.323 12 9.675 9.675 0 0 0 12 21.677 9.675 9.675 0 0 0 21.677 12"
  })));
};
export default SvgPlusCircle;